import S from 'string'
import {tkRegions} from 'vue-tk'
import moment from 'moment'
const nzh = require('nzh/cn')
function role (value) {
  let rolesName = {
    admin: '管理员',
    master: '超级管理员'
  }
  return rolesName[value] || value
}
function field (value, model) {
  if (!model) return ''
  if (typeof value === 'undefined' || value === null) {
    return model.type === 'Boolean' ? '否' : ''
  }
  if (model.type === 'Date') {
    let date = value.iso ? value.iso : value
    return moment(date).format('YYYY-MM-DD HH:mm')
  } else if (model.type === 'String') {
    if (typeof value === 'string') {
      return value.substr(0, 20)
    } else {
      return value
    }
  } else if (model.type === 'Html') {
    return S(value).stripTags().s.substr(0, 20)
  } else if (model.type === 'Boolean') {
    return value ? '是' : '否'
  } else if (model.type === 'Region') {
    return tkRegions.getFullName(value)
  } else if (model.type === 'Select') {
    if (model.items && model.items[value]) {
      return model.items[value]
    } else {
      return ''
    }
  } else if (model.type === 'Pointer') {
    if (value.type === 'Pointer') {
      return ''
    }
    let display = model.cls.display ? model.cls.display : 'objectId'
    let val = value[display]
    return field(val, model.cls.fields[display])
  } else if (model.type === 'GeoPoint') {
    return `经度：${value.longitude}, 纬度：${value.latitude}`
  } else if (model.type === 'Array') {
    let length = value ? value.length : 0
    return model.note + '(' + length + ')'
  } else if (model.type === 'Object') {
    if (!value) return ''
    return value[model.display] ? value[model.display] : '--'
  }
  return value
}
export default {
  iconOfFileType (value) {
    if (/image/.test(value)) {
      return 'photo'
    } else {
      return 'insert_drive_file'
    }
  },
  field (value, model) {
    return field(value, model)
  },
  date (value) {
    if (!value) return ''
    let date = value.iso ? value.iso : value
    return moment(date).format('YYYY-MM-DD HH:mm')
  },
  role (value) {
    return role(value)
  },
  roles (roles) {
    if (!roles) return
    let rolesName = []
    roles.forEach(r => {
      rolesName.push(role(r.name))
    })
    return rolesName.join(',')
  },
  region (id) {
    return tkRegions.getFullName(id)
  },
  sum (arr, name) {
    let sum = 0
    if (arr) {
      arr.forEach(i => {
        sum += parseFloat(i[name])
      })
    }
    return sum
  },
  bigNumber (number) {
    return nzh.encodeB(number)
  }
}



// WEBPACK FOOTER //
// ./src/admin/js/filter.js